export default __webpack_public_path__ + "static/media/bell.813ac4e2.mp3";